let loadGoogleMapsApi = require('load-google-maps-api'); // yarn add load-google-maps-api
let google = null;

export default {
	async loadGoogleMaps() {
		return await loadGoogleMapsApi({
			key: 'AIzaSyCGAzuAl70UYnV0ga_gLCtRktkP1ZNKnWA',
			libraries: ['places'],
		});
	},

	/**
	 * Run Google Automatic Address suggestions
	 */
	implementsGooglePlaces() {
		this.loadGoogleMaps().then(google => {
			if (document.querySelectorAll('.address-prediction input').length > 0) {
				// Load Places/Addresses Autocomplete in a input text field
				new google.places.Autocomplete(document.querySelector('.address-prediction input'), {
					componentRestrictions: { country: 'fr' },
				});
			}
		});
	},

	/**
	 * Request from Google to geocode 1 full address from string
	 *
	 * @param query
	 * @returns {*}
	 */
	async geocodeAddress(query) {
		if (!google) {
			google = await this.loadGoogleMaps();
		}

		let geocoder = new google.Geocoder();

		return new Promise((resolve, reject) => {
			geocoder.geocode({ address: query }, function (results, status) {
				if (status === 'OK') {
					resolve(results);
				} else {
					reject(new Error('This address cannot be resolved.'));
				}
			});
		});
	},

	/**
	 * Search for addresses programatically (like autocomplete).
	 * You can use the place_id then to get more infos from the selected address.
	 *
	 * @param query
	 * @param countries
	 * @returns {Promise<Promise|Promise>}
	 */
	async findPlacesFromQuery(query, countries = ['fr', 're']) {
		if (!google) {
			google = await this.loadGoogleMaps();
		}

		return new Promise((resolve, reject) => {
			let autocompleteService = new google.places.AutocompleteService();

			autocompleteService.getPlacePredictions(
				{ input: query, types: ['geocode'], componentRestrictions: { country: countries } },
				function (predictions, status) {
					if (status === 'OK') {
						resolve(predictions);
					} else {
						reject(new Error('This address cannot be resolved.'));
					}
				}
			);
		});
	},

	/**
	 * Get more informations from an address's place_id. (like postal code, country etc)
	 *
	 * @param query
	 */
	async findByPlaceId(query) {
		if (!google) {
			google = await this.loadGoogleMaps();
		}

		let geocoder = new google.Geocoder();

		return new Promise((resolve, reject) => {
			geocoder.geocode({ placeId: query }, function (results, status) {
				if (status === 'OK') {
					resolve(results);
				} else {
					reject(new Error('This address cannot be resolved.'));
				}
			});
		});
	},

	/**
	 * Find an address component like postal code from the results of Google API. (Like in the results of findByPlaceId).
	 * Available components names are: [street_number] [route], [locality] [administrative_area_level_2] [administrative_area_level_1] [country] [postal_code]
	 *
	 * @param data
	 * @param componentName
	 * @returns {*}
	 */
	findAddressComponent(data, componentName) {
		for (let place of data) {
			return place.address_components.find(o => this.inArray(componentName, o.types));
		}
	},

	inArray(needle, haystack) {
		let length = haystack.length;
		for (let i = 0; i < length; i++) {
			if (haystack[i] === needle) return true;
		}
		return false;
	},
};
